import { ColDef, PYBaseTableTheme } from "@performyard/py-components";

import { type CycleBudgetOverviewTableRow } from "../utils";

import {
	ActingManagerNameCellRenderer,
	BudgetCellRenderer,
	BudgetStatusCellRenderer,
	DirectReportCountCellRenderer,
	ManagerNameCellRenderer,
	ViewBudgetButtonCellRenderer,
} from "../../CellRenderers";

export const cycleBudgetsRowHeightPx = 48;
export const cycleBudgetsHeaderHeightPx = 48;
export const cycleBudgetsMaxRowsBeforeScroll = 7;
export const cycleBudgetsGridViewportHeightPx =
	cycleBudgetsHeaderHeightPx + cycleBudgetsMaxRowsBeforeScroll * cycleBudgetsRowHeightPx;

export const getCycleBudgetsTableTheme = () =>
	PYBaseTableTheme.withParams({
		headerBackgroundColor: "var(--py-neutral-0)",
		borderColor: "transparent",
		wrapperBorder: false,
		wrapperBorderRadius: 0,
		columnBorder: false,
		headerColumnBorder: false,
		rowBorder: false,
		headerRowBorder: false,
		pinnedColumnBorder: false,
	});

export const CycleBudgetsColDefs: ColDef<CycleBudgetOverviewTableRow>[] = [
	{
		headerName: "Manager",
		field: "managerName",
		cellRenderer: ManagerNameCellRenderer,
		flex: 1,
		minWidth: 200,
		sortable: true,
	},
	{
		headerName: "",
		field: "actingManagerName",
		cellRenderer: ActingManagerNameCellRenderer,
		flex: 1,
		minWidth: 180,
		sortable: true,
	},
	{
		headerName: "Direct Reports",
		field: "managerDirectReportCount",
		cellRenderer: DirectReportCountCellRenderer,
		width: 160,
		sortable: true,
	},
	{
		headerName: "Team Budget",
		field: "budget",
		width: 140,
		sortable: false,
		cellRenderer: BudgetCellRenderer,
	},
	{
		headerName: "Status",
		field: "status",
		cellRenderer: BudgetStatusCellRenderer,
		width: 130,
		sortable: false,
	},
	{
		headerName: "Actions",
		cellRenderer: ViewBudgetButtonCellRenderer,
		headerClass: "cycle-budgets-actions-header",
		width: 90,
		sortable: false,
	},
];
